export default __webpack_public_path__ + "static/media/pow-3-med.77c49c6c.jpg";